import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useCallback } from 'react';
import { PageTitleProps } from './PageTitle.types';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { STYLE_VARS } from '../../constants/style-vars';
import { Image } from '../Image';
import { NavigationService } from '../../services/navigation';
import { SHARE_STYLE } from '../../constants/share-style';
import { FONTS } from '../../constants';

const PageTitle: FC<PageTitleProps> = ({
  title,
  icon,
  haveGoBackButton = false,
  handleGoBack,
  style,
  description,
  haveBottomLine = true,
  ...props
}) => {
  const isDesktop = useIsDesktop();

  const handleGoBackButton = useCallback(() => {
    if (handleGoBack) {
      handleGoBack();
    } else {
      NavigationService.pop();
    }
  }, [handleGoBack]);

  if (isDesktop()) {
    return (
      <View
        style={[
          haveBottomLine && {
            borderBottomWidth: 0.5,
            borderBottomColor: STYLE_VARS.fccDarkGrey,
          },
          {
            flexDirection: 'column',
            paddingBottom: 20,
            marginBottom: 20,
          },
        ]}
      >
        <View
          style={[
            {
              flexDirection: 'row',
              alignItems: 'center',
              flex: 1,
              justifyContent: haveGoBackButton ? 'space-between' : 'flex-start',
            },
            style,
          ]}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {icon && (
              <Image
                source={icon}
                style={{
                  height: 25,
                  width: 25,
                  marginRight: 10,
                  resizeMode: 'contain',
                  tintColor: STYLE_VARS.primaryColor,
                }}
              />
            )}
            <Text style={[SHARE_STYLE.titleText, { textAlign: 'center' }]}>
              {title}
            </Text>
          </View>
          {haveGoBackButton && (
            <TouchableOpacity
              style={{ flexDirection: 'row', alignItems: 'center' }}
              onPress={handleGoBackButton}
            >
              <Image
                source={require('../../assets/sport-back-button.png')}
                style={{
                  width: 16,
                  height: 16,
                  resizeMode: 'contain',
                  marginRight: 5,
                }}
              />
              <Text
                style={{
                  fontSize: isDesktop() ? 14 : 12,
                  fontFamily: FONTS.AvenirMedium,
                  color: STYLE_VARS.textColor,
                  fontWeight: '500',
                }}
              >
                BACK
              </Text>
            </TouchableOpacity>
          )}
        </View>
        {description && (
          <Text
            style={{
              color: STYLE_VARS.fccDarkerGrey,
              fontFamily: FONTS.AvenirMedium,
              fontSize: 13,
              textTransform: 'uppercase',
              textAlign: 'left',
              lineHeight: 20,
              fontWeight: '500',
              marginTop: 10,
              letterSpacing: 1,
            }}
          >
            {description}
          </Text>
        )}
      </View>
    );
  }
  return (
    <View
      style={[
        {
          paddingVertical: 20,
          width: '100%',
          flexDirection: 'column',
          marginBottom: 20,
        },
        haveBottomLine && {
          borderBottomColor: STYLE_VARS.fccDarkGrey,
          borderBottomWidth: 0.5,
        },
        style,
      ]}
      {...props}
    >
      <View
        style={{
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: haveGoBackButton ? 'space-between' : 'center',
        }}
      >
        {haveGoBackButton && (
          <TouchableOpacity
            style={{
              padding: 5,
            }}
            onPress={handleGoBackButton}
          >
            <Image
              source={require('../../assets/left-arrow.png')}
              style={{
                height: 14,
                width: 10,
                resizeMode: 'contain',
                tintColor: STYLE_VARS.primaryColor,
              }}
            />
          </TouchableOpacity>
        )}
        <View style={{ flexDirection: 'row' }}>
          {icon && (
            <Image
              source={icon}
              style={{
                height: 24,
                width: 24,
                marginRight: 10,
                tintColor: STYLE_VARS.primaryColor,
                resizeMode: 'contain',
              }}
            />
          )}
          <Text
            style={{
              color: STYLE_VARS.textColor,
              fontFamily: FONTS.IowanOldStyleBTRoman,
              fontSize: 20,
              letterSpacing: 1,
              textTransform: 'uppercase',
            }}
          >
            {title}
          </Text>
        </View>
        {haveGoBackButton && (
          <View
            style={{
              height: 24,
              width: 20,
            }}
          />
        )}
      </View>
      {description && (
        <Text
          style={{
            color: STYLE_VARS.fccDarkerGrey,
            fontFamily: FONTS.AvenirMedium,
            fontSize: 13,
            textTransform: 'uppercase',
            textAlign: 'left',
            lineHeight: 20,
            fontWeight: '500',
            marginTop: 10,
            letterSpacing: 1,
          }}
        >
          {description}
        </Text>
      )}
    </View>
  );
};

export default PageTitle;

const styles = StyleSheet.create({});
